var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SubscriptionPlan',{attrs:{"selectedPlan":_vm.memberRequest.subscriptionPlan},on:{"select":_vm.setSubscription}})}
var staticRenderFns = []

export { render, staticRenderFns }